import { countries, TCountryCode } from 'countries-list';
import { toNumberRaw } from '../number';

const uniqueCurrencies = new Set<string>();
Object.keys(countries).forEach((country) => {
  const countryCode = country as TCountryCode;
  const currency = countries[countryCode].currency[0];
  if (currency !== undefined && currency !== 'ALL') {
    uniqueCurrencies.add(currency);
  }
});
export const currencies = Array.from(uniqueCurrencies).map((currency) => ({
  label: currency,
  value: currency,
}));

export const audMoney = (n: number) =>
  n.toLocaleString(undefined, {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  });

export const fmtCurrency = (v: unknown) => {
  if (v === undefined || v === null || isNaN(toNumberRaw(v)) || v === 0) {
    return '-';
  }
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  }).format(toNumberRaw(v));
};

export const fmtCurrencyWithCents = (v: unknown) => {
  if (v === undefined || v === null || isNaN(toNumberRaw(v))) {
    return '-';
  }
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(toNumberRaw(v));
};
